import Vue from 'vue'

const state = {
    id: 0,
    title: "",
    sub_title: "",
    description: "",
    campaign_url: "",
    start_date: "",
    end_date: "",
    image: "",
    status: "",
    allow_sells: true,
    training_kpi_points: 0,
    training_non_kpi_points: 0,
    training_special_points: 0,
    webinar_points: 0,
    image_banner: '',
    areas: [],
    profiles: [],
    company_branches: [],
    brands: [],
    product_types: [],
    products: [],
    rewards: [],
    photo_types: [],
    error_company_branches: false,
    error_brands: false,
    error_product_types: false,
    error_products: false,
    error_rewards: false,
    user_id: ''
}

const actions = {
    SET_CAMPAIGN(context, [title, sub_title, description, campaign_url, start_date, end_date, image, status, allow_sells, training_kpi_points, training_non_kpi_points, training_special_points, webinar_points, image_banner,  areas, profiles, company_branches, brands, product_types, products, rewards, photo_types]) {
        context.commit('SAVE_CAMPAIGN', [title, sub_title, description, campaign_url, start_date, end_date, image, status, allow_sells, training_kpi_points, training_non_kpi_points, training_special_points, webinar_points, image_banner,  areas, profiles, company_branches, brands, product_types, products, rewards, photo_types])
    },

    SET_ID(context, [id]) {
        context.commit('SAVE_ID', [id])
    },

    SET_TITLE(context, [title]) {
        context.commit('SAVE_TITLE', [title])
    },

    SET_SUBTITLE(context, [sub_title]) {
        context.commit('SAVE_SUBTITLE', [sub_title])
    },

    SET_DESCRIPTION(context, [description]) {
        context.commit('SAVE_DESCRIPTION', [description])
    },

    SET_URL(context, [campaign_url]) {
        context.commit('SAVE_URL', [campaign_url])
    },

    SET_STARTDATE(context, [start_date]) {
        context.commit('SAVE_STARTDATE', [start_date])
    },

    SET_ENDDATE(context, [end_date]) {
        context.commit('SAVE_ENDDATE', [end_date])
    },

    SET_IMAGE(context, [image]) {
        context.commit('SAVE_IMAGE', [image])
    },

    SET_STATUS(context, [status]) {
        context.commit('SAVE_STATUS', [status])
    },

    SET_ALLOW_SELLS(context, [allow_sells]) {
        context.commit('SAVE_ALLOW_SELLS', [allow_sells])
    },

    SET_TRAINING_KPI_POINTS(context, [training_kpi_points]) {
        context.commit('SAVE_TRAINING_KPI_POINTS', [training_kpi_points])
    },

    SET_TRAINING_NON_KPI_POINTS(context, [training_non_kpi_points]) {
        context.commit('SAVE_TRAINING_NON_KPI_POINTS', [training_non_kpi_points])
    },

    SET_TRAINING_SPECIAL_POINTS(context, [training_special_points]) {
        context.commit('SAVE_TRAINING_SPECIAL_POINTS', [training_special_points])
    },

    SET_WEBINAR_POINTS(context, [webinar_points]) {
        context.commit('SAVE_WEBINAR_POINTS', [webinar_points])
    },

    SET_IMAGE_BANNER(context, [image_banner]) {
        context.commit('SAVE_IMAGE_BANNER', [image_banner])
    },

    SET_AREAS(context, [areas]) {
        context.commit('SAVE_AREAS', [areas])
    },

    SET_PROFILES(context, [profiles]) {
        context.commit('SAVE_PROFILES', [profiles])
    },

    SET_COMPANY_BRANCHES(context, [company_branches]) {
        context.commit('SAVE_COMPANY_BRANCHES', [company_branches])
    },

    SET_BRANDS(context, [brands]) {
        context.commit('SAVE_BRANDS', [brands])
    },

    SET_PRODUCT_TYPES(context, [product_types]) {
        context.commit('SAVE_PRODUCT_TYPES', [product_types])
    },

    SET_PRODUCTS(context, [products]) {
        context.commit('SAVE_PRODUCTS', [products])
    },

    SET_REWARDS(context, [rewards]) {
        context.commit('SAVE_REWARDS', [rewards])
    },

    SET_ERROR_DEFAULT(context, [error_company_branches,error_brands, error_product_types, error_products, error_rewards]) {
        context.commit('SAVE_ERROR_DEFAULT', [error_company_branches,error_brands, error_product_types, error_products, error_rewards ])
    },

    SET_ERROR_COMPANY_BRANCHES(context, [error_company_branches]) {
        context.commit('SAVE_ERROR_COMPANY_BRANCHES', [error_company_branches])
    },

    SET_ERROR_BRANDS(context, [error_brands]) {
        context.commit('SAVE_ERROR_BRANDS', [error_brands])
    },

    SET_ERROR_PRODUCT_TYPES(context, [error_product_types]) {
        context.commit('SAVE_ERROR_PRODUCT_TYPES', [error_product_types])
    },

    SET_ERROR_PRODUCTS(context, [error_products]) {
        context.commit('SAVE_ERROR_PRODUCTS', [error_products])
    },

    SET_ERROR_REWARDS(context, [error_rewards]) {
        context.commit('SAVE_ERROR_REWARDS', [error_rewards])
    },

    SET_USER_ID(context, [user_id]) {
        context.commit('SAVE_USER_ID', [user_id])
    },

    SET_PHOTO_TYPES(context, [photo_types]) {
        context.commit('SAVE_PHOTO_TYPES', [photo_types])
    }
}

const mutations = {
    SAVE_CAMPAIGN: (state, [title, sub_title, description, campaign_url, start_date, end_date, image, status, allow_sells, training_kpi_points, training_non_kpi_points, training_special_points, webinar_points, image_banner,  areas, profiles, company_branches, brands, product_types, products, rewards, photo_types]) => {
        Vue.set(state, 'title', title)
        Vue.set(state, 'sub_title', sub_title)
        Vue.set(state, 'description', description)
        Vue.set(state, 'campaign_url', campaign_url)
        Vue.set(state, 'start_date', start_date)
        Vue.set(state, 'end_date', end_date)
        Vue.set(state, 'image', image)
        Vue.set(state, 'status', status)
        Vue.set(state, 'allow_sells', allow_sells)
        Vue.set(state, 'training_kpi_points', training_kpi_points)
        Vue.set(state, 'training_non_kpi_points', training_non_kpi_points)
        Vue.set(state, 'training_special_points', training_special_points)
        Vue.set(state, 'webinar_points', webinar_points)
        Vue.set(state, 'image_banner', image_banner)
        Vue.set(state, 'areas', areas)
        Vue.set(state, 'profiles', profiles)
        Vue.set(state, 'company_branches', company_branches)
        Vue.set(state, 'brands', brands)
        Vue.set(state, 'product_types', product_types)
        Vue.set(state, 'products', products)
        Vue.set(state, 'rewards', rewards)
        Vue.set(state, 'photo_types', photo_types)
    },

    SAVE_ID: (state, [id]) => {
        Vue.set(state, 'id', id)
    },

    SAVE_TITLE: (state, [title]) => {
        Vue.set(state, 'title', title)
    },

    SAVE_SUBTITLE: (state, [sub_title]) => {
        Vue.set(state, 'sub_title', sub_title)
    },

    SAVE_DESCRIPTION: (state, [description]) => {
        Vue.set(state, 'description', description)
    },

    SAVE_URL: (state, [campaign_url]) => {
        Vue.set(state, 'campaign_url', campaign_url)
    },

    SAVE_STARTDATE: (state, [start_date]) => {
        Vue.set(state, 'start_date', start_date)
    },

    SAVE_ENDDATE: (state, [end_date]) => {
        Vue.set(state, 'end_date', end_date)
    },

    SAVE_IMAGE: (state, [image]) => {
        Vue.set(state, 'image', image)
    },

    SAVE_STATUS: (state, [status]) => {
        Vue.set(state, 'status', status)
    },

    SAVE_ALLOW_SELLS: (state, [allow_sells]) => {
        Vue.set(state, 'allow_sells', allow_sells)
    },

    SAVE_TRAINING_KPI_POINTS: (state, [training_kpi_points]) => {
        Vue.set(state, 'training_kpi_points', training_kpi_points)
    },

    SAVE_TRAINING_NON_KPI_POINTS: (state, [training_non_kpi_points]) => {
        Vue.set(state, 'training_non_kpi_points', training_non_kpi_points)
    },

    SAVE_TRAINING_SPECIAL_POINTS: (state, [training_special_points]) => {
        Vue.set(state, 'training_special_points', training_special_points)
    },

    SAVE_WEBINAR_POINTS: (state, [webinar_points]) => {
        Vue.set(state, 'webinar_points', webinar_points)
    },

    SAVE_IMAGE_BANNER: (state, [image_banner]) => {
        Vue.set(state, 'image_banner', image_banner)
    },

    SAVE_AREAS: (state, [areas]) => {
        Vue.set(state, 'areas', areas)
    },

    SAVE_PROFILES: (state, [profiles]) => {
        Vue.set(state, 'profiles', profiles)
    },

    SAVE_COMPANY_BRANCHES: (state, [company_branches]) => {
        Vue.set(state, 'company_branches', company_branches)
    },

    SAVE_BRANDS: (state, [brands]) => {
        Vue.set(state, 'brands', brands)
    },

    SAVE_PRODUCT_TYPES: (state, [product_types]) => {
        Vue.set(state, 'product_types', product_types)
    },

    SAVE_PRODUCTS: (state, [products]) => {
        Vue.set(state, 'products', products)
    },

    SAVE_REWARDS: (state, [rewards]) => {
        Vue.set(state, 'rewards', rewards)
    },

    SAVE_ERROR_COMPANY_BRANCHES: (state, [error_company_branches]) => {
        Vue.set(state, 'error_company_branches', error_company_branches)
    },

    SAVE_ERROR_DEFAULT: (state, [error_company_branches, error_brands, error_product_types, error_products, error_rewards]) => {
        Vue.set(state, 'error_company_branches', error_company_branches)
        Vue.set(state, 'error_brands', error_brands)
        Vue.set(state, 'error_product_types', error_product_types)
        Vue.set(state, 'error_products', error_products)
        Vue.set(state, 'error_rewards', error_rewards)
    },

    SAVE_ERROR_BRANDS: (state, [error_brands]) => {
        Vue.set(state, 'error_brands', error_brands)
    },

    SAVE_ERROR_PRODUCT_TYPES: (state, [error_product_types]) => {
        Vue.set(state, 'error_product_types', error_product_types)
    },

    SAVE_ERROR_PRODUCTS: (state, [error_products]) => {
        Vue.set(state, 'error_products', error_products)
    },

    SAVE_ERROR_REWARDS: (state, [error_rewards]) => {
        Vue.set(state, 'error_rewards', error_rewards)
    },

    SAVE_USER_ID: (state, [user_id]) => {
        Vue.set(state, 'user_id', user_id)
    },

    SAVE_PHOTO_TYPES: (state, [photo_types]) => {
        Vue.set(state, 'photo_types', photo_types)
    }
}

const getters = {

    id: state => {
        return state.id
    },

    title: state => {
        return state.title
    },

    sub_title: state => {
        return state.sub_title
    },

    description: state => {
        return state.description
    },

    campaign_url: state => {
        return state.campaign_url
    },

    start_date: state => {
        return state.start_date
    },

    end_date: state => {
        return state.end_date
    },

    image: state => {
        return state.image
    },

    status: state => {
        return state.status
    },

    allow_sells: state => {
        return state.allow_sells
    },

    training_kpi_points: state => {
        return state.training_kpi_points
    },

    training_non_kpi_points: state => {
        return state.training_non_kpi_points
    },

    training_special_points: state => {
        return state.training_special_points
    },

    webinar_points: state => {
        return state.webinar_points
    },

    image_banner: state => {
        return state.image_banner
    },

    areas: state => {
        return state.areas
    },

    profiles: state => {
        return state.profiles
    },

    company_branches: state => {
        return state.company_branches
    },

    brands: state => {
        return state.brands
    },

    product_types: state => {
        return state.product_types
    },

    products: state => {
        return state.products
    },

    rewards: state => {
        return state.rewards
    },

    error_company_branches: state => {
        return state.error_company_branches
    },

    error_brands: state => {
        return state.error_brands
    },

    error_product_types: state => {
        return state.error_product_types
    },

    error_products: state => {
        return state.error_products
    },

    error_rewards: state => {
        return state.error_rewards
    },

    user_id: state => {
        return state.user_id
    },

    photo_types: state => {
        return state.photo_types
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}